import { createTheme } from '@material-ui/core/styles';
import { blue, pink, red } from '@material-ui/core/colors';
import { alpha } from '@material-ui/core';

// Create a theme instance.
export const theme = createTheme({
	palette: {
		primary: {
			main: '#556cd6',
		},
		secondary: {
			main: '#19857b',
		},
		error: {
			main: red.A400,
		},
		background: {
			default: '#fff',
		},
	},
	shape: {
		borderRadius: 8
	}
});

export const nodePalette = {
	active: blue[500],
	activeOpacity: alpha(blue[500], 0.25),
	selection: pink[500],
	border: "#DEDEDE",
	connector: "#F5F5F5",
	background: "#FAFAFA",
}

export const shape = {
	borderRadius: '8px'
}